import style from './CardWrapper.module.scss';
import React, {useEffect, useState} from "react";
import {Card, getCompanyInfoCard} from "../../../axios/api"


const Item: React.FC<Card> = ({text, image}) => {
    return (
        <div className={style.cardWrapperItem}>
            <div className={style.text}>{text}</div>
            <img className={style.image} src={image} alt={text}/>
        </div>
    );
};

export default function CardWrapper(props: any) {
    const [card, setCard] = useState<Card[] | null>(null);

    useEffect(() => {
        getCompanyInfoCard().then(setCard).catch(console.error);
    }, []);

    return (
        <div className={style.container}>
            {card?.map((item, index) => (
                <Item key={index} text={item.text} image={process.env.REACT_APP_IMAGE_URL + item.image}/>
            ))}
        </div>
    )
}